import React, { useEffect } from 'react';
import { Body } from '../../common/components/v2';
import { Resource } from '../../common/constants/resource';
import styles from './styles.module.scss';

export const RouteNotFound = () => {
  useEffect(() => {
    // Update the document title using the browser API
    document.title = `${Resource.PAGE_NOT_FOUND}${Resource.NORA_M_DASH}${Resource.APPLICATION_TITLE}`;
    console.error('Route not found');
  }, []);
  return (
    <div className={styles.NotFound}>
      <Body>{Resource.PAGE_NOT_FOUND}</Body>
    </div>
  );
};
